module.exports = __webpack_public_path__ + "img/new1-img2.2355dafd.png";